<template>
  <div class="next-prev-container">
    <button
      class="prev-btn pill-button-lg"
      v-if="previous"
      @click="$emit('prev-step')"
    >
      <inline-svg src="/images/icons/chevron-left-solid.svg"></inline-svg>
    </button>
    <next-button
      :label="title"
      :disabled="disabled"
      :background-color="nextColor[0]"
      :text-color="nextColor[1]"
      @click="$emit('next-step')"
    />
  </div>
</template>

<script>
import NextButton from './NextButton.vue'

export default {
  components: {
    NextButton
  },
  props: {
    disabled: Boolean,
    title: String,
    previous: Boolean,
    nextColor: {
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.next-prev-container {
  position: absolute;
  margin-top: -56px;
  right: 0;
  height: 45px;
  //display: none;

  @media only screen and (min-width: 620px) {
    display: flex;
  }

  button {
    //    box-shadow: rgba(0, 0, 0, 0.4) 0 0 5px;
    background-color: var(--arch-color);
    color: var(--arch-text-color);

    &.icon :deep(g) {
      fill: var(--arch-text-color);
    }

    &:disabled {
      opacity: 1;
      background: #f9f9f9 !important;
      color: #a7a7a7 !important;
      :deep(g) {
        fill: #a7a7a7 !important;
      }
    }
  }
}

.prev-btn {
  width: 45px;
  padding: 0;
  //  height: 32px;
  border-radius: 50%;
  margin-right: 7px;
  box-shadow: var(--default-shadow);

  svg {
    width: 13px;
    //margin-left: -3px;
    //margin-top: 1px;

    :deep(g) {
      fill: var(--arch-text-color);
    }
  }

  /*   &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0 4px 15px 0px;
  } */
}
</style>
